import { render, staticRenderFns } from "./DraggableActivity.vue?vue&type=template&id=b38e5c38&"
import script from "./DraggableActivity.vue?vue&type=script&lang=js&"
export * from "./DraggableActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports